import styled, { css } from 'styled-components';

import { media } from '@theme/media';

export const alignContentTopStyles = css`
  ${media.mobile} {
    justify-content: flex-start;
  }
`;

export const Container = styled.div``;
